module.exports = __webpack_public_path__ + "media/images/fasttrack-427563b0c2a2492653c9829e8b760463.svg";